import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import theme from 'styles/themes/wikifactory';

import DocumentHead from 'legacyComponents/documentHead';
import { FourOhFour } from 'apps/fourOhFour/index';

import { FileViewer } from 'libs/rendering';
import { viewerURLtoPreviewInfo } from 'libs/rendering/utils';
import { ProgressBar } from 'legacyComponents/progressBar';
import RFQForm from 'apps/rfq/rfqForm';

@withNamespaces()
@observer
export class FileTabNew extends React.Component {
  render() {
    const { manager, returnLink } = this.props;
    if (!manager.repositoryItem && !manager.loading) {
      return <FourOhFour type='File' />;
    }
    const file = manager.repositoryItem?.reference?.file;

    if (!file && manager.loading) {
      return <ProgressBar visible bgColor={theme.color.wfBlue} />;
    }

    const { filename } = file;
    const filePath = file.headPath || file.path;

    const previewInfo = viewerURLtoPreviewInfo(`${MAIN_URL}/${filePath}`);

    return (
      <>
        <DocumentHead
          title={`${filename} - ${returnLink.params.slug}`}
          imagePath={previewInfo.image.url}
          videoInfo={previewInfo.video}
        />
        <FileViewer file={file}>
          <RFQForm file={file} />
        </FileViewer>
      </>
    );
  }
}

FileTabNew.propTypes = {
  routerStore: PropTypes.object,
  manager: PropTypes.object,
  returnLink: PropTypes.object,
};
